import { Avatar, Badge, IconButton, Tooltip } from "@mui/material"
import { FC, useCallback, useState } from "react"
import defaultAvatar from "../assets/default_avatar.png"
import { useAuthStatus } from "../hooks/useAuthStatus"
import { UserDrawer } from "./UserDrawer"

type UserAvatarProps = {
  isOnline?: boolean
}
export const UserAvatar: FC<UserAvatarProps> = ({ isOnline }) => {
  // useState isuserDrawerOpen
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState(false)

  const handleAvatarClick = useCallback(() => {
    setIsUserDrawerOpen((isUserDrawerOpen) => !isUserDrawerOpen)
  }, [])
  const onClose = useCallback(() => {
    setIsUserDrawerOpen(false)
  }, [])

  const { email, imageUrl } = useAuthStatus()
  return (
    <>
      <Tooltip title={email}>
        <IconButton onClick={handleAvatarClick} sx={{ p: 0 }}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
            sx={{
              "& .MuiBadge-dot": {
                backgroundColor: isOnline ? "green" : "grey",
                width: 10,
                height: 10,
                borderRadius: "50%",
              },
            }}
          >
            <Avatar alt="User" src={imageUrl || defaultAvatar} />
          </Badge>
        </IconButton>
      </Tooltip>
      {isUserDrawerOpen && <UserDrawer onClose={onClose} />}
    </>
  )
}
